import React from 'react';
import styles from './styleConstants.module.css';

export const H2 = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={className ? `${styles.h2} ${className}` : styles.h2} {...props}>
    {children}
  </h2>
);
